import Api from "@/api"

function getDefaultState() {
  return {
    groupList: {},
    totalGroups: null,
  }
}

const gatekeeperProgramGroup = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    FLUSH_STATE(state) {
      Object.assign(state, getDefaultState())
    },
    ADD_GROUPS_TO_LIST(state, groupList) {
      state.groupList.push(...groupList)
    },
    SET_GROUP_LIST(state, groupList) {
      state.groupList = groupList
    },
    SET_GROUPS_TOTAL(state, total) {
      state.totalGroups = total
    },
  },
  actions: {
    flushState({ commit }) {
      commit("FLUSH_STATE")
    },
    async getGroup(ctx, groupSlug) {
      let res = await Api.gatekeeperProgramGroup.getGroup(groupSlug)
      return res.data
    },

    async getGroupList(
      { commit, state, rootGetters },
      { groupType, schoolSlug = null, override = true, usePagination = true }
    ) {
      // :str groupType: which group type to fetch (if empty, fetch all groups)
      // :boolean override: whether to override the groups list or not (i.e., extend)
      const params = usePagination ? rootGetters["pagination/apiParams"] : {}
      if (schoolSlug) {
        params.activity_order__school__slug = schoolSlug
      }
      if (groupType) {
        params.group_type = groupType
      }
      const mutation = override ? "SET_GROUP_LIST" : "ADD_GROUPS_TO_LIST"
      let res = await Api.gatekeeperProgramGroup.getGroupList(params)
      commit(mutation, res.data.results)
      commit("SET_GROUPS_TOTAL", res.data.count)
      return state.groupList
    },
    async getGroupsByFilter(ctx, params) {
      // get groups by filter and but do not save to store
      let res = await Api.gatekeeperProgramGroup.getGroupList(params)
      return res.data.results
    },
    async updateGroup(ctx, { groupSlug, data }) {
      let res = await Api.gatekeeperProgramGroup.updateGroup(groupSlug, data)
      return res.data
    },
    deleteGroup(ctx, groupSlug) {
      return Api.gatekeeperProgramGroup.deleteGroup(groupSlug)
    },
    async getConsumers(
      { dispatch, rootGetters },
      { groupSlugs, usePagination = true }
    ) {
      // get all consumers under a group
      // :array groupSlug: array of group slugs to fetch consumers by
      const params = usePagination ? rootGetters["pagination/apiParams"] : {}
      let res = await Api.gatekeeperProgramGroup.getConsumers(
        groupSlugs,
        params
      )
      if (usePagination) {
        dispatch("pagination/setTotalServerItems", res.data.count, {
          root: true,
        })
      }
      return res.data.results
    },
    async updateGroupConsumers(ctx, { groupSlug, consumerSlugs }) {
      // override group consumers and move the removed ones to container only
      // :Array consumerSlugs: consumers to apply to group
      let res = await Api.gatekeeperProgramGroup.updateGroupConsumers(
        groupSlug,
        consumerSlugs
      )
      return res.data
    },
  },
}

export default gatekeeperProgramGroup
